import { render } from "./deploy.vue?vue&type=template&id=f3f4abd0"
import script from "./deploy.vue?vue&type=script&lang=ts"
export * from "./deploy.vue?vue&type=script&lang=ts"
script.render = render

export default script